import {
  type ReportSeverityKey,
  isReportSeverityKey,
} from '@ipfabric/utils/report';
import { type FC, useCallback } from 'react';
import { Icon } from '../Icon/Icon';
import { Option } from './IntentFilterOption';
import { severityDots } from './IntentFilterSelect.styles';
import type { IntentFilterSelectOptions } from './IntentFilterSelect.types';

interface Props {
  setOpen: (open: boolean) => void;
  options: IntentFilterSelectOptions;
  onChange: (value: ReportSeverityKey | null) => void;
  value: ReportSeverityKey | null;
  focused?: number | null;
}

export const IntentFilterDropdown: FC<Props> = (props) => {
  const handleClick = useCallback(
    (value: ReportSeverityKey | null) => {
      props.onChange(value);
      props.setOpen(false);
    },
    [props.setOpen, props.onChange],
  );
  const options = Object.entries(props.options);
  return (
    <div className='absolute top-full flex flex-col w-7 py-2xs border border-default border-t-0 rounded-sm rounded-t-none bg-white z-popup drop-shadow'>
      {options.map(([severity, description], index) => {
        if (isReportSeverityKey(severity)) {
          return (
            <Option
              key={severity}
              description={description}
              selected={severity === props.value}
              focused={props.focused === index}
              onClick={() => handleClick(severity)}
              severity={severity}
            >
              {severityDots[severity]}
            </Option>
          );
        }
        return null;
      })}
      {props.value !== null && (
        <Option
          description='Remove filter'
          focused={props.focused === options.length}
          selected={false}
          onClick={() => handleClick(null)}
        >
          <Icon glyph='fa-xmark-circle' size='xs' iconStyle='duotone' />
        </Option>
      )}
    </div>
  );
};
